import { MAX_FILE_SIZE_MB, VALID_TYPES, UPLOAD_ERROR_MESSAGES } from '../constants';

export const isValidFile = (file, setError) => {
  if (!VALID_TYPES.includes(file.type)) {
    setError(UPLOAD_ERROR_MESSAGES.UNSUPPORTED_FILE_TYPE);
    return false;
  }

  if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    setError(UPLOAD_ERROR_MESSAGES.FILE_SIZE_EXCEEDED);
    return false;
  }
  setError(null);
  return true;
};

/**
 * A hang guard, not a latency budget - deliberately generous, so a slow image on a slow
 * connection is never called broken.
 */
export const IMAGE_PROBE_TIMEOUT_MS = 10000;

/**
 * Whether a URL resolves to an image the browser can actually render. Probes by loading it;
 * a URL can 200 and still be undisplayable. Always settles - timing out resolves false.
 */
export const isImageUrlValid = async (url, timeoutMs = IMAGE_PROBE_TIMEOUT_MS) => {
  if (!url) {
    return false;
  }
  return new Promise((resolve) => {
    const img = new window.Image();
    let timer = null;
    let settled = false;

    // All three paths race; first answer wins and must also tear down the other two.
    const settle = (isValid) => {
      if (settled) {
        return;
      }
      settled = true;
      clearTimeout(timer);
      img.onload = null;
      img.onerror = null;
      resolve(isValid);
    };

    img.onload = () => settle(true);
    img.onerror = () => settle(false);
    timer = setTimeout(() => settle(false), timeoutMs);
    // Assigned last: this starts the load, and the handlers have to be attached before it.
    img.src = url;
  });
};